// extracted by mini-css-extract-plugin
export default {"scan-qr":"ScanQr_scan-qr__Kveh4","hi":"ScanQr_hi__o6SX1"};